import React from "react";
import { useFormContext } from "react-hook-form";
import { Button } from '@mui/material';
import ReplyIcon from '@mui/icons-material/Reply';

const ResetButton = ({ onReset }) => {
  const { reset } = useFormContext();

  const handleClick = () => {
    reset();
    onReset?.();
  }
  
  return (
    <Button
      variant="contained"
      color="error"
      size="medium"
      startIcon={<ReplyIcon />}
      onClick={handleClick}
    >
      Отказ
    </Button>
  );
};

export default ResetButton;